// extracted by mini-css-extract-plugin
export default {"navigationButton":"NavButton_navigationButton__ybgeD"};